export default import.meta.ROLLUP_FILE_URL_Mm1OQWLPALQQGSpRYv2zSw